module.exports = __webpack_public_path__ + "img/voda.592fea77.jpeg";